import axios from "@/axios.js";

const STUTUS_LOADING = "loading";
const STATUS_ERROR = "error";
const paths = {
    get: "/products/list",
    create: "/vocher/create",
    update: "/vocher/update",
    delete: "/vocher/delete",

    getById(id) {
        return `/products/detail/${id}`;
    },
};

const defaultFilters = {
    search: "",
    page: 1,
};

export default {
    namespaced: true,
    state: {
        status: null,
        lastUpdated: null,
        products: [],

        filters: defaultFilters,
        meta: {
            current_page: 1,
            last_page: 1,
            per_page: 1,
            total: 0,
        },
    },
    mutations: {
        SET_PRODUCTS(state, products) {
            state.products = products;
            state.lastUpdated = new Date();
        },

        SET_FILTERS(state, filters) {
            state.filters = {
                ...state.filters,
                ...filters,
            };
        },

        SET_META(state, meta) {
            state.meta = {
                ...state.meta,
                ...meta,
            };
        },

        SET_STATUS(state, status) {
            state.status = status;
        },
    },
    actions: {
        async fetchProducts({ commit }, filters = defaultFilters) {
            if (this.state.status == STUTUS_LOADING) {
                return;
            }

            commit("SET_STATUS", STUTUS_LOADING);

            const payload = {
                ...this.state.meta,
                ...filters,
            };

            if (payload.page == 1) {
                commit("SET_PRODUCTS", []);
            }

            commit("SET_FILTERS", filters);

            await new Promise((resolve) => setTimeout(resolve, 1000));

            try {
                const { data: response } = await axios.get(paths.get, {
                    params: payload,
                });

                commit("SET_PRODUCTS", response.data);

                // set options
                commit("SET_META", response.meta);

                return response.data;
            } catch (error) {
                console.error("fetchProducts error", error);
                commit("SET_ORDERS", []);
                commit("SET_STATUS", STATUS_ERROR);

                throw error;
            } finally {
                commit("SET_STATUS", null);
            }
        },

        async fetchProductById({ commit }, id) {
            try {
                const { data: response } = await axios.get(paths.getById(id));
                return response.data;
            } catch (error) {
                // TODO: handle error
                console.error("fetchProducts error", error);
                throw error;
            }
        },
    },
    getters: {
        lastUpdated: (state) => state.lastUpdated,
        list: (state) => state.products,
        meta: (state) => state.meta,
        status: (state) => state.status,
        filters: (state) => state.filters,
    },
};
